import { utils } from '@easydata/core';
import { getElementAbsolutePos } from './ui-utils';
import { domel } from '../utils/dom_elem_builder';
var touchEventIsDefined = typeof TouchEvent !== 'undefined';
export var DropEffect;
(function (DropEffect) {
    DropEffect["None"] = "none";
    DropEffect["Allow"] = "allow";
    DropEffect["Forbid"] = "forbid";
})(DropEffect || (DropEffect = {}));
var EqDragEvent = /** @class */ (function () {
    function EqDragEvent(item, dragImage, sourceEvent) {
        this.dropEffect = DropEffect.Allow;
        this.pageX = 0;
        this.pageY = 0;
        this.item = item;
        this.dragImage = dragImage;
        this.data = item.data;
        this.sourceEvent = sourceEvent;
        if (sourceEvent && sourceEvent instanceof MouseEvent) {
            this.pageX = sourceEvent.pageX,
                this.pageY = sourceEvent.pageY;
        }
        if (sourceEvent && touchEventIsDefined && sourceEvent instanceof TouchEvent
            && sourceEvent.touches[0]) {
            this.pageX = sourceEvent.touches[0].pageX,
                this.pageY = sourceEvent.touches[0].pageY;
        }
    }
    return EqDragEvent;
}());
export { EqDragEvent };
var Position = /** @class */ (function () {
    function Position(ev) {
        if (ev && ev instanceof MouseEvent) {
            this.x = ev.pageX,
                this.y = ev.pageY;
        }
        if (ev && touchEventIsDefined && ev instanceof TouchEvent && ev.touches[0]) {
            this.x = ev.touches[0].pageX,
                this.y = ev.touches[0].pageY;
        }
    }
    return Position;
}());
var DragManager = /** @class */ (function () {
    function DragManager() {
        this.delta = 5;
        this.draggableItem = null;
        this.dragImage = null;
        this.finishedSuccessfully = false;
        this.mouseDownPosition = null;
        this.containerDescriptors = [];
        this.containerDescriptorIndex = -1;
        this.dropEffect = DropEffect.None;
        this.classPrefix = 'eqjs-drop';
        this.DRAG_DISABLED_ATTR = 'drag-disabled';
    }
    DragManager.prototype.registerDraggableItem = function (descriptor) {
        var _this = this;
        var element = descriptor.element;
        if (!element) {
            throw Error("Element in draggle item is null or undefined");
        }
        element.ondragstart = function () {
            return false;
        };
        var detectDragging = function (ev) {
            if (element.hasAttribute(_this.DRAG_DISABLED_ATTR)) {
                return;
            }
            ev.preventDefault();
            if (ev instanceof MouseEvent) {
                ev.stopPropagation();
            }
            var cursorPosition = new Position(ev);
            if (Math.abs(cursorPosition.x - _this.mouseDownPosition.x) > _this.delta
                || Math.abs(cursorPosition.y - _this.mouseDownPosition.y) > _this.delta) {
                startDragging(ev);
            }
        };
        var mouseMoveEventListener = function (ev) {
            _this.mouseMoveDragListener(ev);
        };
        var startDragging = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            element.removeEventListener('mousemove', detectDragging);
            element.removeEventListener('touchmove', detectDragging);
            _this.finishedSuccessfully = false;
            if (descriptor.beforeDragStart)
                descriptor.beforeDragStart();
            _this.dragImage = domel('div')
                .setStyle('position', 'absolute')
                .setStyle('z-index', '65530')
                .toDOM();
            document.body.appendChild(_this.dragImage);
            _this.dragImage.appendChild(element.cloneNode(true));
            if (descriptor.renderer) {
                descriptor.renderer(_this.dragImage);
            }
            _this.dropEffect = DropEffect.None;
            _this.updateCusror(_this.dropEffect);
            _this.updateImageClass(_this.dropEffect);
            _this.draggableItem = {
                element: element,
                scope: descriptor.scope,
                data: descriptor.data
            };
            _this.updateDragItemPosition(ev);
            var event = new EqDragEvent(_this.draggableItem, _this.dragImage, ev);
            event.dropEffect = _this.dropEffect;
            if (descriptor.onDragStart) {
                descriptor.onDragStart(event);
            }
            if (_this.dropEffect !== event.dropEffect) {
                _this.dropEffect = event.dropEffect;
                _this.updateImageClass(_this.dropEffect);
            }
            document.addEventListener('mousemove', mouseMoveEventListener, true);
            document.addEventListener('touchmove', mouseMoveEventListener, true);
        };
        var mouseDownListener = function (ev) {
            if (touchEventIsDefined && ev instanceof TouchEvent) {
                ev.preventDefault();
            }
            _this.mouseDownPosition = new Position(ev);
            element.addEventListener('mousemove', detectDragging);
            element.addEventListener('touchmove', detectDragging);
            document.addEventListener('mouseup', mouseUpListener);
            document.addEventListener('touchend', mouseUpListener);
        };
        element.addEventListener('mousedown', mouseDownListener);
        element.addEventListener('touchstart', mouseDownListener);
        var mouseUpListener = function (ev) {
            _this.mouseDownPosition = null;
            element.removeEventListener('mousemove', detectDragging);
            element.removeEventListener('touchmove', detectDragging);
            document.removeEventListener('mousemove', mouseMoveEventListener, true);
            document.removeEventListener('touchmove', mouseMoveEventListener, true);
            if (_this.draggableItem) {
                endDraggind(ev);
            }
        };
        var endDraggind = function (ev) {
            try {
                if (_this.containerDescriptorIndex >= 0) {
                    var dropContDesc = _this.containerDescriptors[_this.containerDescriptorIndex];
                    var container = {
                        element: dropContDesc.element,
                        scopes: dropContDesc.scopes,
                        data: dropContDesc.data
                    };
                    var event_1 = new EqDragEvent(_this.draggableItem, _this.dragImage, ev);
                    try {
                        if (container.scopes.indexOf(_this.draggableItem.scope) >= 0
                            && _this.dropEffect === DropEffect.Allow) {
                            _this.finishedSuccessfully = true;
                            if (dropContDesc.onDrop) {
                                dropContDesc.onDrop(container, event_1);
                            }
                        }
                    }
                    finally {
                        if (dropContDesc.onDragLeave) {
                            dropContDesc.onDragLeave(container, event_1);
                        }
                    }
                }
            }
            finally {
                try {
                    var event_2 = new EqDragEvent(_this.draggableItem, _this.dragImage, ev);
                    event_2.data.finishedSuccessfully = _this.finishedSuccessfully;
                    if (descriptor.onDragEnd) {
                        descriptor.onDragEnd(event_2);
                    }
                }
                finally {
                    _this.draggableItem = null;
                    if (_this.dragImage && _this.dragImage.parentElement) {
                        _this.dragImage.parentElement.removeChild(_this.dragImage);
                    }
                    _this.dragImage = null;
                    _this.finishedSuccessfully = false;
                    document.removeEventListener('mouseup', mouseUpListener);
                    document.removeEventListener('touchend', mouseUpListener);
                }
            }
        };
    };
    DragManager.prototype.registerDropContainer = function (descriptor) {
        var element = descriptor.element;
        if (!element) {
            throw Error("Element in drop container is null or undefined");
        }
        this.containerDescriptors.push(descriptor);
    };
    DragManager.prototype.removeDropContainer = function (descriptorOrSlot) {
        var descs = this.containerDescriptors
            .filter(function (desc) { return desc === descriptorOrSlot
            || desc.element == descriptorOrSlot; });
        if (descs) {
            for (var _i = 0, descs_1 = descs; _i < descs_1.length; _i++) {
                var desc = descs_1[_i];
                utils.removeArrayItem(this.containerDescriptors, desc);
            }
        }
    };
    DragManager.prototype.mouseMoveDragListener = function (ev) {
        if (ev instanceof MouseEvent) {
            ev.preventDefault();
        }
        ev.stopPropagation();
        this.updateDragItemPosition(ev);
        if (this.containerDescriptorIndex == -1) {
            for (var i = 0; i < this.containerDescriptors.length; i++) {
                var descriptor = this.containerDescriptors[i];
                if (this.detectDragEnterEvent(descriptor.element, ev)) {
                    this.containerDescriptorIndex = i;
                    break;
                }
            }
            if (this.containerDescriptorIndex >= 0) {
                this.dragEnterEvent(ev);
            }
        }
        else {
            var descriptor = this.containerDescriptors[this.containerDescriptorIndex];
            if (this.detectDragLeaveEvent(descriptor.element, ev)) {
                this.dragLeaveEvent(ev);
                this.containerDescriptorIndex = -1;
            }
        }
        if (this.containerDescriptorIndex >= 0) {
            var descriptor = this.containerDescriptors[this.containerDescriptorIndex];
            var container = {
                element: descriptor.element,
                scopes: descriptor.scopes,
                data: descriptor.data
            };
            if (container.scopes.indexOf(this.draggableItem.scope) >= 0) {
                var event_3 = new EqDragEvent(this.draggableItem, this.dragImage, ev);
                event_3.dropEffect = this.dropEffect;
                if (descriptor.onDragOver) {
                    descriptor.onDragOver(container, event_3);
                }
            }
        }
    };
    DragManager.prototype.updateCusror = function (dropEffect) {
        switch (dropEffect) {
            case DropEffect.Allow:
                this.setCursorStyle(this.dragImage, 'grabbing');
                break;
            case DropEffect.Forbid:
                this.setCursorStyle(this.dragImage, 'no-drop');
                break;
            default:
                this.setCursorStyle(this.dragImage, 'grabbing');
                break;
        }
    };
    DragManager.prototype.updateImageClass = function (dropEffect) {
        this.dragImage.classList.remove(this.classPrefix + "-allow");
        this.dragImage.classList.remove(this.classPrefix + "-forbid");
        this.dragImage.classList.remove(this.classPrefix + "-none");
        switch (dropEffect) {
            case DropEffect.Allow:
                this.dragImage.classList.add(this.classPrefix + "-allow");
                break;
            case DropEffect.None:
                this.dragImage.classList.add(this.classPrefix + "-none");
                break;
            case DropEffect.Forbid:
                this.dragImage.classList.add(this.classPrefix + "-forbid");
                break;
            default:
                this.dragImage.classList.add(this.classPrefix + "-none");
                break;
        }
    };
    DragManager.prototype.setCursorStyle = function (element, cursor) {
        if (element) {
            element.style.cursor = cursor;
            for (var i = 0; i < element.children.length; i++) {
                this.setCursorStyle(element.children[i], cursor);
            }
        }
    };
    DragManager.prototype.updateDragItemPosition = function (ev) {
        if (this.dragImage) {
            var pos = new Position(ev);
            this.dragImage.style.top = (pos.y - this.dragImage.offsetHeight / 2) + 'px';
            this.dragImage.style.left = (pos.x - this.dragImage.offsetWidth / 2) + 'px';
        }
    };
    DragManager.prototype.dragEnterEvent = function (ev) {
        var descriptor = this.containerDescriptors[this.containerDescriptorIndex];
        var container = {
            element: descriptor.element,
            scopes: descriptor.scopes,
            data: descriptor.data
        };
        if (container.scopes.indexOf(this.draggableItem.scope) >= 0) {
            var event_4 = new EqDragEvent(this.draggableItem, this.dragImage, ev);
            event_4.dropEffect = DropEffect.Allow;
            if (descriptor.onDragEnter) {
                descriptor.onDragEnter(container, event_4);
            }
            this.dropEffect = event_4.dropEffect;
            this.updateCusror(this.dropEffect);
            this.updateImageClass(this.dropEffect);
        }
        else {
            if (this.dropEffect !== DropEffect.Forbid) {
                this.dropEffect = DropEffect.None;
                this.updateCusror(this.dropEffect);
                this.updateImageClass(this.dropEffect);
            }
        }
    };
    DragManager.prototype.dragLeaveEvent = function (ev) {
        var descriptor = this.containerDescriptors[this.containerDescriptorIndex];
        var container = {
            element: descriptor.element,
            scopes: descriptor.scopes,
            data: descriptor.data
        };
        if (container.scopes.indexOf(this.draggableItem.scope) >= 0) {
            var event_5 = new EqDragEvent(this.draggableItem, this.dragImage, ev);
            event_5.dropEffect = DropEffect.None;
            if (descriptor.onDragLeave) {
                descriptor.onDragLeave(container, event_5);
            }
            this.dropEffect = event_5.dropEffect;
            this.updateCusror(this.dropEffect);
            this.updateImageClass(this.dropEffect);
        }
    };
    DragManager.prototype.detectDragEnterEvent = function (container, ev) {
        var containerPos = getElementAbsolutePos(container);
        var pos = new Position(ev);
        if (pos.y < containerPos.y || pos.y > containerPos.y + container.offsetHeight) {
            return false;
        }
        if (pos.x < containerPos.x || pos.x > containerPos.x + container.offsetWidth) {
            return false;
        }
        return true;
    };
    DragManager.prototype.detectDragLeaveEvent = function (container, ev) {
        var containerPos = getElementAbsolutePos(container);
        var pos = new Position(ev);
        if (pos.y > containerPos.y && pos.y < containerPos.y + container.offsetHeight
            && pos.x > containerPos.x && pos.x < containerPos.x + container.offsetWidth) {
            return false;
        }
        return true;
    };
    return DragManager;
}());
export { DragManager };
//global variable
export var eqDragManager = new DragManager();
//# sourceMappingURL=drag_manager.js.map